import { render, staticRenderFns } from "./BlockActions.vue?vue&type=template&id=77863e76&scoped=true"
import script from "./BlockActions.vue?vue&type=script&lang=js"
export * from "./BlockActions.vue?vue&type=script&lang=js"
import style0 from "./BlockActions.vue?vue&type=style&index=0&id=77863e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77863e76",
  null
  
)

export default component.exports